<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-flex">
        <div class="ts-relative ts-w-full">
          <input
            v-model.trim="search"
            ref="search"
            type="text"
            class="ts-w-full ts-border ts-float-right ts-px-2 ts-py-1 ts-rounded ts-outline-none ts-pr-6"
            :placeholder="$t('saleContract.searchProductList')"
          />
          <span
            class="ts-absolute ts-right-0 ts-mt-1 ts-mr-2"
            style="margin-top: 7px"
            ><i class="fa fa-search"></i
          ></span>
        </div>
      </div>
      <br />
      <div class="max-h ts-px-3">
        <table class="ts-w-full">
          <thead>
            <tr>
              <th
                class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-1 ts-whitespace-no-wrap"
              >
                {{ $t('saleContract.productGroup') }}
              </th>
              <th
                class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-1 ts-whitespace-no-wrap"
              >
                {{ $t('saleContract.barcode') }}
              </th>
              <th
                class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-1 ts-whitespace-no-wrap"
              >
                {{ $t('saleContract.productName') }}
              </th>
              <th
                class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-1 ts-whitespace-no-wrap ts-text-right"
              >
                {{ $t('saleContract.qty') }}
              </th>
              <th
                class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-1 ts-whitespace-no-wrap ts-text-right"
              >
                {{ $t('saleContract.salePrice') }}
              </th>
              <th
                class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-1 ts-whitespace-no-wrap"
              >
                {{ $t('actions') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="ts-border-b ts-border-gray-400"
              v-for="(product, index) in productList"
              :key="index"
            >
              <td class="ts-text-xs ts-px-2 ts-py-1">
                {{ product.pro_group_name_en }}
              </td>
              <td class="ts-text-xs ts-px-2 ts-py-1">{{ product.barcode }}</td>
              <td class="ts-text-xs ts-px-2 ts-py-1">
                {{
                  product.product_name_kh ? product.product_name_kh + ' | ' : ''
                }}
                {{ product.product_name_en }}
              </td>
              <td class="ts-text-right ts-px-2 ts-py-1 ts-w-32">
                <input
                  v-model.number="product.qty"
                  type="number"
                  placeholder="qty"
                  class="ts-w-full ts-outline-none ts-border-t ts-px-2 ts-py-1 ts-rounded ts-text-xs"
                  @keypress.enter="addItem(product)"
                />
              </td>
              <td class="ts-text-xs ts-px-2 ts-py-1 ts-text-right">
                {{
                  getSalePrice({
                    product_id: product.product_id
                  })
                }}
              </td>
              <td style="width: 1%" class="text-center ts-pl-4">
                <a
                  href="#"
                  v-tooltip="$t('add')"
                  @click.prevent="addItem(product)"
                  class="ts-mb-0"
                >
                  <i class="fa fa-plus"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'productList',
  props: ['value'],
  data () {
    return {
      search: '',
      products: [],
      loading: false,
      model: {}
    }
  },
  created () {
    this.model = this.value
    this.fetchProduct()
    this.$nextTick(() => {
      this.$refs.search.focus()
    })
  },
  computed: {
    ...mapGetters('wholesale/saleContract', ['isDefaultUom', 'getCost']),
    productList () {
      return this.products.filter(
        p =>
          !_.includes(
            this.model.item_list.map(el => el.product_id),
            p.product_id
          )
      )
    },
    getSalePrice:
      vm =>
      ({ product_id }) => {
        if (product_id && vm.products.length) {
          let pro = vm.products.find(p => p.product_id == product_id)
          var uom = pro.uom_category.unit_of_measures.find(
            u => u.is_default == true
          )
          var salecode = pro.sale_code.find(s => s.uom_id == uom.uom_id)
          return salecode.product_price
            ? salecode.product_price.sale_price
              ? salecode.product_price.sale_price
              : 0
            : 0
        }
        return 0
      },
    thbRate () {
      let foundFx = this.$store.state.wholesale.saleContract.exchangeRate.find(
        e => e.to_currency == 'THB'
      )
      if (foundFx) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        return (this.model.fx_rate_thb = parseFloat(foundFx.fx_rate))
      }
      return (this.model.fx_rate_thb = 32)
    }
  },
  methods: {
    ...mapActions('wholesale/saleContract', ['getProduct']),
    addItem (product) {
      this.$store.commit('wholesale/saleContract/SET_PRODUCT', product)

      var uom_id = this.isDefaultUom(product.product_id)
      var price = this.getSalePrice({ product_id: product.product_id })
      this.model.item_list.push({
        product_id: product.product_id,
        uom_id: uom_id,
        quantity: product.qty ? product.qty : 1,
        unit_price: price,
        remarks: '',
        amount: price * (product.qty ? product.qty : 1),
        amount_in_bath: price * this.thbRate,
        storage_location: product.storage_name_en
          ? product.storage_name_en
          : '',
        product_name_en: product.product_name_en,
        barcode: product.barcode,
        balance: 'no refresh',
        cost: this.getCost({
          product_id: product.product_id,
          uom_id: uom_id
        })
      })
      this.$emit('calculate')
      this.$nextTick(() => {
        this.$refs.search.focus()
        this.$refs.search.select()
      })
    },
    fetchProduct () {
      this.loading = true
      this.products = []
      this.getProduct({
        filter: {
          search: this.search
        }
      })
        .then(response => {
          this.products = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchProduct()
    }, 800)
  }
}
</script>

<style scoped>
.max-h {
  height: 270px;
  max-height: 270px;
  overflow: scroll;
}
table {
  /* white-space: nowrap; */
  margin: 0;
  border: none;
  border-collapse: separate;
  border-spacing: 0;
  /* table-layout: fixed; */
  /* border: 1px solid black; */
}
table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: rgb(22, 102, 145);
  color: white;
}
</style>
